import { render, staticRenderFns } from "./CourseEffectDescription.vue?vue&type=template&id=004e639c&"
import script from "./CourseEffectDescription.vue?vue&type=script&lang=js&"
export * from "./CourseEffectDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports